export const standardStyle = `
body {
  font-family: Arial, Helvetica, sans-serif;
}
.print-tpl-box {
  background-color: #fff;
}
.header {
}
.catption-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-direction: row-reverse;
}
.catption-title {
  font-size:18pt;
  font-weight:bold;
  margin-top:12pt;
}
.logo-box {
}
.logo-img {
  display: block;
  margin-right: 6pt;
}
.bg-img {
  z-index:-1;
  position:absolute;
  left:0px;
  top:0px;
}
.sub-header-box {
  display: flex;
  flex-direction: row;
  margin-top:0pt;
  justify-content: space-between;
}
.left-info {
  width: 50%;
  padding: 6pt;
  padding-left: 12pt;
  font-size:10pt;
  line-height:15pt;
  border: 1px solid #BbBbBb;
}
.Paytype {
  font-weight:bold;
  font-size:11pt;
}
.shipping {
  font-weight:bold;
  font-size:9pt;
}
.shipping-big-text {
  font-weight:bold;
  font-size:13pt;
  border: 1px solid #383838;
  padding: 2px;
  border-radius: 4px;
}
.Areatype {
  font-weight:bold;
  font-size:9pt;
}
.csr-name,.attention {
  font-weight:bold;
  font-size:14pt;
}
.middle-info {
  width: 20%;
  margin-top: 4pt;
  padding-left: 12pt;
  font-size:12pt;
  line-height:20pt;
}
.bolder-text-first {
  font-weight:bold;
}
.bolder-text {
  font-weight:bold;
  margin-top:6pt;
}
.bolder-table-text {
  font-weight:bold;
  font-size:11pt;
  margin-top:6pt;
  text-align:right;
  padding-right:12pt;
}
.underscore {
  border-bottom:1px solid #464646;
}
.right-info {
  margin-top: 6pt;
  padding-right: 12pt;
  border-right: 1px solid #BbBbBb;
  width: 30%;
  font-size:10pt;
  line-height:16pt;
}
.right-info-caption {
  font-weight:bold;
}
.footer {
  margin-top:0%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.footer-left {
  width: 50%;
}
.footer-right {
  width: 50%;
}
.end-of-page {
  margin: 1% 0 0 0;
  font-size: 10pt;
}
.endpage-small {
  font-size: 10pt;
  color:#BFBFBF;
}
.divider-line {
  margin-top:6px;
  width: 100%;
  height: 2px;
  border-top: dashed #818181 2px;
}
.payment-info {
  font-size:18pt;
  font-weight:bold;
  margin-bottome: 30pt;
}
.payment-static-info {
  font-size:10pt;
  line-height:15pt;
}
.smallest-text {
  font-size:6pt;
}
.location-head-small {
  font-size:8pt;
}
.lines-table-head {
  font-weight:bold;
  border-bottom:1px solid #BFBFBF;
  line-height: 28pt;
}
.lines-table-body {
  // border-bottom:1px solid #BFBFBF;
  // line-height: 22pt;
  padding:10px 0;
}
.amt-line-column {
  padding-right:6px;
  font-weight:bold;
}
.location-line-small {
  font-size:7pt;
  color:#343434;
}
.lines-total {
  line-height: 20pt;
  text-align: right;
}
.lines-total-stong {
  display:inline-block;
  font-weight:bold;
  font-size:14pt;
  background-color: #F5F5F5;
}
.lines-total-grey-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.lines-total-grey {
  display:inline-block;
  background-color: #F5F5F5;
}
.comment {
  width:500px;
  font-size:13pt;
  text-align: left;
  font-weight:bold;
  word-wrap: break-word;
}
.lines-total-divider {
  height: 1px;
  margin-left:60%;
  width:40%;
  margin-top:4px;
  margin-bottom:4px;
  text-align: right;
  border-top: solid #646464 1px;
}
.due-date-area {
  line-height: 18pt;
}
.due-date-text {
  font-size:13pt;
  font-weight:bold;
}
.due-date-small-text {
  font-size:9pt;
}
.notice-text {
  border:1px solid #787878;
}
.static-info2 {
  font-size:10pt;
  line-height: 14pt;
}
.footer-sign-text {
  font-size:15px;
  color: #6C6C6C;
}
.ref-small-text {
  font-size:12px;
}
.csr-abn-text {
  font-size:12px;
}
`
